import React from 'react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import { modalStore } from './ModalStore';

@withRouter
@observer
export class Modal extends React.Component {
	render() {
		return (
			<div className={`${modalStore.isV2 ? 'ModalV2' : 'Modal'}`}>
				{this.renderModal()}
			</div>
		);
	}

	renderModal() {
		if (modalStore.isV2) {
			return this.renderV2Modal();
		}
		return this.renderV1Modal();
	}

	renderV1Modal() {
		return (
			<div className={`modal ${this.getModalClass()} ${modalStore.position}`}>
				<div className="modal-background" aria-hidden="true" />
				<div className={`modal-card ${modalStore.size}`}>
					<header className="modal-card-head">
						<p className="modal-card-title title is-2 is-size-4-mobile">
							{this.getTitle()}
						</p>
						<a href={'void'} onClick={e => this.handleClickClose(e)}>
							<img src="/ats/icons/close-3-icon.svg" alt="close" />
						</a>
						<div className="border-line" />
					</header>
					{modalStore.getModalComponent()}
				</div>
			</div>
		);
	}

	renderV2Modal() {
		return (
			<div className={`modal ${this.getModalClass()} ${modalStore.position}`}>
				<div className="modal-background" aria-hidden="true" />
				<div className={`modal-card-v2 ${modalStore.size}`}>
					{modalStore.getModalComponent()}
				</div>
			</div>
		);
	}

	getTitle() {
		return modalStore.title ? modalStore.title : '';
	}

	getModalClass() {
		return modalStore.isOpen === true ? 'is-active ' : '';
	}

	handleClickClose(e) {
		e.preventDefault();
		if (modalStore.modalComponent?.props?.handleCancelClose) {
			modalStore.modalComponent.props.handleCancelClose('close');
		}
		modalStore.closeDialog();
	}
}
